const DeviceWorkConditions = ['中等', '良好', '恶劣']

var runTimes = []
for (let index = 1; index < 37; index++) {
  runTimes.push(index * 2000)
}
const DeviceRunTimes = runTimes

const QuotationStatusMap = {
  1: {
    name: '待提审',
    type: 'info',
  },
  2: {
    name: '审批中',
    type: 'info',
  },
  3: {
    name: '未通过',
    type: 'danger',
  },
  4: {
    name: '审批通过',
    type: 'success',
  },
  5: {
    name: '已转单',
    type: 'success',
  },
  6: {
    name: '待转单',
    type: 'success',
  },
}
const CustomerOrderStatusMap = {
  1: {
    name: '待提交',
    type: 'info',
  },
  2: {
    name: '审批中',
    type: 'info',
  },
  3: {
    name: '审批不通过',
    type: 'danger',
  },
  4: {
    name: '审批通过',
    type: 'success',
  },
  // 10: {
  //     name: '采购/发货',
  //     type: 'primary'
  // },
  // 20: {
  //     name: '实施',
  //     type: 'primary'
  // },
  100: {
    name: '已完成',
    type: 'success',
  },
}

const TodoTypeMap = {
  1: {
    name: '报价审批',
    type: 'info',
  },
  2: {
    name: '订单确认',
    type: 'info',
  },
  3: {
    name: '报价拜访',
    type: 'info',
  },
  4: {
    name: '客户拜访',
    type: 'info',
  },
  5: {
    name: '订单回款',
    type: 'danger',
  },
  6: {
    name: '拜访提醒',
    type: 'warning',
  },
}

const ApproveEventTypeMap = {
  1: '报价单',
  2: '商城订单',
  3: '服务请求',
  4: '公告',
  5: '报价单',
  6: '小程序',
}

const CustomerOrderLogMap = {
  1: '从报价单转化为订单',
  2: '创建报价单',
  3: '提交审核',
  4: '审核通过',
  5: '审核未通过',
  6: '订单进入采购状态',
  7: '订单进入实施状态',
  8: '订单完成',
  9: '生成采购单',
  10: '添加回款',
  11: '添加发货记录',
  12: '添加出库单',
  13: '删除采购单',
  14: '添加合同',
  15: '删除合同',
  16: '增加成本',
  17: '更新成本',
  18: '删除成本',
  19: '删除回款',
  20: '修改回款',
  21: '添加开票记录',
  22: '编辑开票记录',
  23: '删除开票记录',
  24: '删除报价单',
  25: '恢复报价单',
  26: '完成报价单',
}
const PurchaseOrderLogMap = {
  1: '创建采购单',
  2: '更新采购单',
  3: '提交审核',
  4: '审核通过，等待入库',
  5: '审核不通过',
  6: '已入库',
}

const CustomerFollowupTypes = [
  { label: '现场拜访', value: 1 },
  // { label: '报价拜访', value: 2 },
  // { label: '客户招待', value: 3 },
  { label: '电话拜访', value: 4 },
]

const ServiceQuestLevelMap = {
  // 1: '一般',
  2: '紧急',
  // 3: '特别紧急'
}

const ServiceQuestSourceMap = {
  1: '400电话',
  2: '经销商',
  3: '客户自发',
}

const ServiceQuestStatusMap = {
  1: '待评估',
  2: '进行中',
  3: '已关闭',
  // 4: '挂起中',
  100: '已完成',
}

const CutomerLogTypes = [
  {
    label: '所有动态',
    value: 0,
  },
  {
    label: '现场拜访',
    value: 2,
  },
  {
    label: '报价拜访',
    value: 3,
  },
  {
    label: '电话拜访',
    value: 18,
  },
  {
    label: '客户招待',
    value: 4,
  },
]

const PurchaseOrderStatusMap = {
  1: {
    name: '待提交审批',
    type: 'info',
  },
  3: {
    name: '待审批',
    type: 'info',
  },
  5: {
    name: '审批未通过',
    type: 'warning',
  },
  7: {
    name: '待入库',
    type: 'primary',
  },
  8: {
    name: '待确认入库',
    type: 'primary',
  },
  9: {
    name: '已入库',
    type: 'success',
  },
}

const ShippingRecordStatusMap = {
  1: {
    name: '待出库',
    type: 'info',
  },
  2: {
    name: '已出库',
    type: 'success',
  },
  // 3: {
  //     name: '待确认出库',
  //     type: 'primary'
  // },
  // 5: {
  //     name: '已出库',
  //     type: 'success'
  // },
}

const Monthes = ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']

const CustomerActiveMap = {
  1: '新客户',
  2: '客户拜访',
  3: '订单拜访',
  4: '客户招待',
  5: '信息更新',
  6: '信息更新',
  7: '信息更新',
  8: '报价中',
  9: '报价中',
  10: '新增设备',
  11: '设备更新',
  12: '信息更新',
  13: '信息更新',
  14: '信息更新',
  15: '信息更新',
  16: '信息更新',
  17: '订单拜访',
  18: '新报价单',
  26: '新服务请求',
}

const CustomerLogMap = {
  1: '创建客户',
  2: '现场拜访',
  3: '报价拜访',
  4: '客户招待',
  5: '新增联系人',
  6: '修改联系人',
  7: '删除联系人',
  8: '新报价单',
  9: '更新报价单',
  10: '新增设备',
  11: '更新设备',
  12: '信息更新',
  13: '新增发票',
  14: '修改发票',
  15: '删除发票',
  16: '删除报价单',
  17: '订单回款',
  18: '新报价单',
  19: '电话拜访',
  20: '删除客户',
  21: '恢复客户',
  22: '恢复报价单',
  23: '删除报价单',
  24: '恢复报价单',
  25: '完成报价单',
  26: '新服务请求',
}

const CustomerDeviceStatusMap = {
  0: '使用中',
  1: '迁移',
  2: '报废',
  3: '停用',
  4: '出口',
  5: '设备错误',
  6: 'GPP',
}

const AreaTextMap = {
  1: 'East',
  2: 'South',
  3: 'West',
  4: 'North',
}

const CustomerStatusMap = {
  1: '正常',
  2: '丢失',
  3: '注销',
}

const CustomerCategroyMap = {
  '1': '一般经销商',
  '2': '授权代理商',
  '3': 'OEM商',
  // '4': 'OEM1',
  // '5': 'OEM2',
  '6': '最终用户',
  '7': '其他',
}

const CsutomerIndustries = ['采矿', '船运', '房地产&租赁', '工商管理/企业管理', '公共行政管理', '行政&后勤管理&环境治理', '建筑', '教育', '金融&保险', '零售业', '农林渔牧', '批发贸易', '其他服务（除公共管理）', '水利&环境&公共设施管理', '文化&休闲&娱乐', '信息传播', '医疗保健&社会援助', '运输&仓储', '制造业', '住宿&餐饮服务业', '专业科学研究&技术服务']

const DealerRanks = {
  '0': '无',
  '1': '铂金授权经销商',
  '2': '金牌授权经销商',
  '3': '银牌授权经销商',
  '4': '铜牌授权销售商',
  '5': '特殊折扣经销商',
  '6': '一般授权经销商',
  '7': '一级OEM经销商',
  '8': '二级OEM经销商',
  '9': '三级OEM经销商',
}

const DealerCategories = {
  '1': '一般经销商',
  '2': '授权代理商',
  '3': 'OEM商',
  // '4': 'OEM1',
  // '5': 'OEM2',
  '6': '最终用户',
  '7': '其他',
}

const LoginEntrances = {
  1: '企业微信',
  2: '网页',
}

const ServiceQuestMode = {
  0: '未评估',
  1: '保内维修点维修',
  2: '保内寄回STC',
  3: '销售跟进',
  4: '海外维修/检查',
  5: '本地处理',
  6: '转CDC',
  7: '保外现场维修',
  8: '保外寄回STC',
  9: '海外收费维修',
  10: '翻新回购',
  11: '保内现场维修',
  12: '保外维修点维修',
  13: '返回PC',
}

const ServiceQuestModeStatus = {
  0: '发起',
  1: '评估',
  2: 'STC接收',
  3: '开始检查',
  4: '完成报告并上传',
  5: '质保判定',
  6: '定货',
  7: '备件齐',
  8: '维修完成发货',
  9: '备件齐完成派工',
  10: '质保判定',
  11: '完成服务',
  12: '方案确认',
  14: '销售处理',
  15: '维修点收货',
  16: '维修点发货',
  20: '完成服务',
  30: '发出',
  32: '返回判定',
  34: '发回客户',
  55: '关单',
  62: 'CDC处理',
  65: '关单',
  72: '备件齐完成派工',
  74: '完成服务',
  82: 'STC接收',
  84: '定货',
  86: '备件齐',
  88: '维修完成发货',
  91: '发出',
  93: '海外返回',
  95: '发回客户',
  97: '审批',
  98: '回滚',
  99: '关闭',
  100: '评估方案更新',
  101: '销售处理',
  111: '方案确认',
  112: '备件齐完成派工',
  113: '质保判定',
  114: '销售处理',
  115: '完成服务',
  116: '工程师上门',
  120: '备件齐完成派工',
  121: '完成服务',
  130: 'PC接收',
  131: '完成报告并上传',
  132: '维修完成发货',
  200: '领取了工单',
  300: '评论回复',
  301: '转移负责人',
  302: '添加审批人',
}

const ServiceQuestModeAuth = {
  0: 'serviceQuestCreate',
  1: 'serviceQuestEvaluate',
  2: 'serviceQuestFlowSTCReceive',
  3: 'serviceQuestFlowPlan',
  4: 'serviceQuestFlowInspectionReport',
  5: 'serviceQuestFlowWarrantyDecision',
  6: 'serviceQuestFlowOrderGood',
  7: 'serviceQuestFlowRepair',
  8: 'serviceQuestFlowDeliver',
  9: 'serviceQuestFlowFSDispatch',
  10: 'serviceQuestFlowFSWarrantyDecision',
  11: 'serviceQuestFlowFSFinish',
  12: 'serviceQuestFlowCheckProposal',
  14: 'serviceQuestFlowFSSaleCheck',
  20: 'serviceQuestFlowFinish',
  30: 'serviceQuestFlowSend',
  32: 'serviceQuestFlowBackCheck',
  34: 'serviceQuestFlowShipBack',
  55: 'serviceQuestFlowLocalClose',
  62: 'serviceQuestFlowToCDC',
  65: 'serviceQuestFlowCDCClose',
  72: 'serviceQuestFlowTollFSDispatch',
  74: 'serviceQuestFlowTollFSFinish',
  82: 'serviceQuestFlowTollSTCReceive',
  84: 'serviceQuestFlowTollOrderGood',
  86: 'serviceQuestFlowTollRepair',
  88: 'serviceQuestFlowTollDeliver',
  91: 'serviceQuestFlowTollSend',
  93: 'serviceQuestFlowTollBackCheck',
  95: 'serviceQuestFlowTollShipBack',
  101: 'serviceQuestFlowSTCSaleCheck',
  111: 'serviceQuestFlowCFSFixPlan',
  112: 'serviceQuestFlowCFSDispatch',
  113: 'serviceQuestFlowCFSWarrantyDecision',
  114: 'serviceQuestFlowCFSSaleCheck',
  115: 'serviceQuestFlowCFSFinish',
  116: 'serviceQuestFlowCFSDoorService',
  120: 'serviceQuestFlowDealerDispatch',
  121: 'serviceQuestFlowDealerFinish',
  130: 'serviceQuestFlowPCReceive',
  131: 'serviceQuestFlowPCInspectionReport',
  132: 'serviceQuestFlowPCDeliver',
}

const ServiceQuestFlow = {
  0: [0, 1],
  1: [0, 1, 9, 10, 14, 11],
  2: [0, 1, 2, 3, 4, 5, 101, 6, 7, 8],
  3: [0, 1, 20],
  4: [0, 1, 30, 32, 34],
  5: [0, 1, 55],
  6: [0, 1, 62, 65],
  7: [0, 1, 72, 74],
  8: [0, 1, 82, 84, 86, 88],
  9: [0, 1, 91, 93, 95],
  10: [0, 1],
  11: [0, 1, 111, 112, 116, 113, 114, 115],
  // 11: [0, 1, 111, 112, 113, 114, 115],
  12: [0, 1, 120, 121],
  13: [0, 1, 130, 131, 132],
}

const ServiceQuestResponseTip = {
  0: '',
  101: '',
  201: '请通过文本框或附件填入运单信息和备注信息',
  202: '',
  203: '',
  204: '',
  205: '',
  301: '若客户不愿自费修理，请直接关闭此请求',
  302: '',
}

const WarrantyTypes = ['新品标准质保期', '新品延保期', '维修品质保期', '二手产品质保期', '出质保期']

const PSETestings = ['STC检测', '海外检测', '销售退换货', '客户不维修', 'FSE现场检测', 'PC质量问题 + PC维修']

const NoticeCategoryMap = {
  1: '内部人员',
  2: '所有中间商',
  3: '全平台',
  4: '自选',
  5: '中间商',
  6: '授权经销商',
  7: 'OEM',
}

const FunctionalRoles = {
  Sale: '销售',
  Telesale: '电话销售',
  NewProductSale: '新品销售',
}

const UsedDeviceStatusMap = {
  1: {
    name: '出售中',
    type: 'primary',
  },
  10: {
    name: '停售中',
    type: 'gray',
  },
  100: {
    name: '已售出',
    type: 'success',
  },
}

const DeviceQuestStatusMap = {
  1: {
    name: '未提交',
    type: 'primary',
  },
  2: {
    name: '审核中',
    type: 'info',
  },
  99: {
    name: '已关闭',
    type: 'gray',
  },
  100: {
    name: '已结束',
    type: 'success',
  },
}

const ProductPromotionStatusMap = {
  1: {
    name: '未发布',
    type: 'primary',
  },
  2: {
    name: '进行中',
    type: 'success',
  },
  99: {
    name: '已关闭',
    type: 'info',
  },
  100: {
    name: '已结束',
    type: 'info',
  },
}

const SMSStatusMap = {
  1: {
    type: 'info',
    name: '发送中',
  },
  2: {
    type: 'success',
    name: '发送成功',
  },
  3: {
    type: 'danger',
    name: '发送失败',
  },
}

const CommodityOrderStatusMap = {
  0: {
    name: '待提交',
    type: 'default',
  },
  1: {
    name: '已取消',
    type: 'default',
  },
  // 1: {
  //     name: '待提交',
  //     type: 'info'
  // },
  2: {
    name: '待审批',
    type: 'info',
  },
  3: {
    name: '审批不通过',
    type: 'danger',
  },
  4: {
    name: '待审批',
    type: 'info',
  },
  5: {
    name: '待支付',
    type: 'primary',
  },
  6: {
    name: '已支付',
    type: 'success',
  },
  // 7: {
  //     name: '待发货',
  //     type: 'success'
  // },
  // 8: {
  //     name: '待收货',
  //     type: 'success'
  // },
  // 10: {
  //     name: 'EC审批',
  //     type: 'primary'
  // },
  // 11: {
  //     name: 'EC审批不通过',
  //     type: 'danger'
  // },
  12: {
    name: '已支付',
    type: 'primary',
  },
  13: {
    name: '已支付',
    type: 'danger',
  },
  // 15: {
  //     name: '总价审批',
  //     type: 'primary'
  // },
  // 16: {
  //     name: '总价审批不通过',
  //     type: 'danger'
  // },
  // 18: {
  //     name: '调价审批',
  //     type: 'primary'
  // },
  // 19: {
  //     name: '调价审批不通过',
  //     type: 'danger'
  // },
  100: {
    name: '已完成',
    type: 'success',
  },
}

const FlowCategoryMap = {
  '1': '销售报价',
  // '2': '商城订单',
  // '3': '服务请求',
  '4': '公告',
}

const NoticeStatusMap = {
  1: {
    type: 'success',
    name: '已发布',
  },
  2: {
    type: 'info',
    name: '待审批',
  },
  3: {
    type: 'danger',
    name: '草稿',
  },
}

const ServiceQuestCMMCategory = [
  { key: 1, value: '设备故障/质量问题' },
  { key: 2, value: '本地物流问题' },
  { key: 3, value: '工厂发货问题' },
  { key: 5, value: 'STC付费维修' },
  { key: 6, value: 'FS付费维修' },
  { key: 4, value: '其它' },
]

const ServiceQuestCMMCategoryTextMap = {
  '设备故障/质量问题': 1,
  '本地物流问题': 2,
  '工厂发货问题': 3,
  '其它': 4,
  'STC付费维修': 5,
  'FS付费维修': 6,
}

const ServiceQuestCategory = {
  1: ['漏油-其它', '漏油-轴封', '漏水', '噪音异响', '卡死', '震动异常', '抽速慢', '电机故障', '无法启动', '温度高', '极限真空差', '其它'],
  2: ['包装损坏', '新品货损', '新品漏发', '新品错发', '备件货损', '油品货损', '备件/油品错发', '备件/油品漏发', '其它'],
  3: ['参照本地物流'],
  4: [],
  5: [],
  6: [],
}

const CustomerUsages = [
  { name: 'Y001-半导体行业', desc: '晶圆的生产，例如镀膜(PVD, CVD, PECVD) ，光刻，蚀刻，离子注入等。' },
  { name: 'Y002-大面积镀膜', desc: '用于大型基材的镀膜：a) 建筑玻璃，包括电致变色玻璃和真空玻璃(VIG)。b) 柔性玻璃、金属和聚合物基板(例如，用于包装、电容器、隔热膜、钢带)。镀膜机形式: 连续线或R2R卷对卷镀膜机。' },
  { name: 'Y003-测量分析', desc: '传感器; 除质谱仪、电子显微镜和检漏仪外，其他分析仪器、一般测量仪器(如微量天平、x射线光谱仪等)。' },
  { name: 'Y004-核磁​共振​成像', desc: 'a) 为核磁共振人体扫描仪磁体降温。b) 为核磁共振光谱仪降温。' },
  { name: 'Y005-工业镀模', desc: '工业镀膜用于：a) 精密光学，如滤光片、透镜、棱镜。b) 眼镜。c) 镜子或反射器。d) 汽车(前后灯) 、电枢、珠宝的3D和装饰镀膜。e) 工具、齿轮、轴的工具镀膜。镀膜机形式：单体或箱式镀膜机。' },
  { name: 'Y006-医疗', desc: '生产灭菌设备、手套箱、医用离心机、牙科真空、医院负压吸引，以及所有其他使用真空的医疗器械。' },
  { name: 'Y007-交通运输', desc: 'a)车辆部件和系统(如汽车空调、制动液管路，制冷管路等)的抽空和加注。生产相关设备。制动液的脱气，化油器和发动机的检漏等。b) 汽车生产商 + 供应商。c) 加油站油气回收。d) 飞机制造 + 供应商。e) 铁路列车制造 + 供应商。' },
  { name: 'Y008-照明', desc: '各种灯具 / 照明设备的抽空和灌装。' },
  { name: 'Y011-工业炉', desc: 'a)广义上的热处理炉的生产(淬火、退火、渗氮、渗碳、回火);烧结工艺(金属、陶瓷，例如用于MIM或磁铁生产);钎焊/焊接;气氛控制热处理炉(如H2, Ar, NH3，等离子体)。b) 金属热处理、硬化设施; 温度和真空起重要作用的(表面)处理(在“涂层”的意义上，不使用其他 / 外来材料涂层)。' },
  { name: 'Y012-化工/制药', desc: '各类基本化学品或药物的生产商，例如: a) 洗涤剂和脂肪酸生产商; 化妆品, 香水制造商。b) 聚合物和纤维及其原材料的制造商; 合成纤维制造商; 硅胶产品制造商。c) 油漆和涂料的制造商。d) 炼油、原油加工。' },
  { name: 'Y014-制冷与空调(RAC)', desc: '加工和修理设施中的制冷装置、冷却回路和热泵系统的抽空、测试和加注设备的生产和使用。生产电冰箱或空调(RAC) 。生产热管和热泵。' },
  { name: 'Y015-大学和研究院', desc: 'a)大学(集中采购大学，没有其他研究所编号分配)，学院，实验室做分析。b) 分析实验室; 学校; 公共机构; 办公室; 邮政; 铁路; 跨地区组织; 协会等。c) 研发分销商，只服务于大学和研究所。' },
  { name: 'Y016-系统和机械', desc: 'a)其它项未列出的真空应用设备或系统(包括例如工业清洗系统、浸渍设备、其它类型层压机、皮革烘干、氟化系统);真空脱气或干燥系统;等离子体清洗或表面清洗;油脱气;干燥设备，如变压器或其他高压传输部件或绝缘油)。b) 所有工程公司不包括: 化工 / 制药市场以及太阳能层压设备的工程公司、制造商。' },
  { name: 'Y017-工业气体', desc: '气体的生产、灌装、运输、废弃处理，客户有中银、林德、液化空气等。VPSA(真空变压吸附)天然气生产设备。' },
  { name: 'Y018-能源技术', desc: 'a)发电厂(只有传统的天然气、石油或燃煤电厂) 。如E.ON Power, RWE, NBB等电厂运营商。b)集中供热: 使用余热加热水，例如发电厂的废余热用于供暖、公共建筑或游泳池。用于对双夹套热水管进行抽真空的系统。c) 市政供暖。' },
  { name: 'Y019-电力', desc: '使用真空进行干燥或脱气的电气设备生产商，如干燥、脱气、化成等，例如: a) 高压元件(如变压器、引线、衬套)制造商。b) PCB板或电容器制造商。c) 电源开关，灭弧室抽空。d) 电气驱动和控制(如电机)。e) 发电机，例如风力发电机。' },
  { name: 'Y023-科研设备制造商', desc: 'a) 制造表面分析等研发分析设备的公司。b) 制造加速器、同步加速器、光束线等研发设备的公司。' },
  { name: 'Y024-(食品)包装', desc: '真空或惰性气体食品或其他产品的包装系统; 包装成型(深压)。' },
  { name: 'Y026-数据存储', desc: '光学存储器(如cd、CD - ROM、CD - RW) 、磁存储器(如光盘、面板) 、磁头的镀膜。' },
  { name: 'Y030-莱宝子公司', desc: '无。' },
  { name: 'Y041-莱宝欧洲代理商', desc: '合同代理人和贸易公司。' },
  { name: 'Y042-莱宝亚太/中国代理商', desc: '合同代理人和贸易公司。' },
  { name: 'Y043-莱宝美洲代理商', desc: '合同代理人和贸易公司。' },
  { name: 'Y044-莱宝中东/非洲代理商', desc: '合同代理人和贸易公司。' },
  { name: 'Y050-实验室贸易商', desc: '实验室贸易商。' },
  { name: 'Y051-冷冻干燥(药品)', desc: '医药产品的冷冻干燥。' },
  { name: 'Y052-激光', desc: '气体激光器(不是固体激光器) ，例如 - CO2激光器快流和慢流，- CO2激光器密封，-其他气体激光器。例如：Bystronic。' },
  { name: 'Y053-大型研究中心', desc: '国家，国际研究中心;加速器，同步加速器;不包括: 大学！' },
  { name: 'Y054-航天和航空', desc: 'a) 高空和空间环模舱的制造商和用户; 卫星技术; 航天和航空研究及供应商; 例如美国宇航局。b) 军队，国防工业。' },
  { name: 'Y055-冷冻干燥(食品)', desc: '食品冻干; 也可以处理类似的产品如鲜花，文件或书籍。' },
  { name: 'Y056-电子显微镜', desc: '电子显微镜。' },
  { name: 'Y057-光谱仪', desc: '质谱仪，飞行时间质谱仪，核磁共振谱仪，光学谱仪。' },
  { name: 'Y058-检漏仪', desc: '检漏仪。' },
  { name: 'Y059-工业低温技术', desc: 'a) 超导磁体和电机的冷却(磁共振成像和核磁共振谱仪除外)。b) 探测器和电子设备的冷却。' },
  { name: 'Y061-储能', desc: '能源储存(电力、动能、热能)组件的生产和回收，例如:电池(一次和二次/可充电)，锂电池(及类似技术)，蓄电池，超级电容，飞轮储能(如汽车、专用车辆、火车、风力涡轮机)太阳热能。' },
  { name: 'Y071-容器制造', desc: 'a)绝热瓶、绝热运输容器、液态气体容器的抽空/干燥。b) LNG - 低温罐生产。c) 容器泄漏试验(压力上升法)。d) 建筑保温用VIP(真空保温板)的生产。' },
  { name: 'Y072-吸持和搬运', desc: 'a)用于真空输送液体、粉末、颗粒或粉尘的各种吸持和搬运装置。b) 吸取元件。c) 用于木材、复合材料等的数控铣床。' },
  { name: 'Y073-其他机械', desc: 'a) 所有不能被划分到其他部分的机器或部件生产商。b) 为塑料模具制造商提供的工具。c) 小零件，配件，例如电枢的制造商。d) 精密机械 / 光学等。e) 例如供暖系统的生产; 一切与房屋、水处理有关的设备。' },
  { name: 'Y074-检漏系统', desc: '检漏系统的制造商。' },
  { name: 'Y076-竞争对手的销售', desc: '真空泵或压缩机制造商(如Pfeiffer, Busch, Anest Iwata, Stokes, Rietschle)。' },
  { name: 'Y077-焊接机器', desc: '焊接设备或机器制造商(如电子束或等离子焊接)。' },
  { name: 'Y078-冶金', desc: '生产用于钢铁或特殊金属脱气的铸造炉或钢包炉(如VD, VOD, RH, VIM等)。通过熔铸、钢材或特殊金属脱气生产原金属或金属零件，或者生产金属半成品零件。a) 钢厂。b) 特殊合金生产。c) 铸造厂。d) 铝型材。e) 铁 / 金属板材，例如管、线、锁、电枢; 螺丝; 餐具和许多其他的' },
  { name: 'Y079-晶体生长', desc: '熔化炉或晶体生长系统(如直拉式或DSS型)的制造太阳能或半导体用晶棒或晶圆(如硅)的制造商，晶体生长设备的用户。' },
  { name: 'Y082-化工制药仪器', desc: 'a)在化学或制药工艺工程中用于基本化学操作的系统、仪器或机器的OEM制造商，例如 干燥- 蒸馏- 反应- 过滤- 蒸发。b) 设计或建造化工或制药工厂的制造商或工程公司。' },
  { name: 'Y085-橡塑', desc: '各种塑料零件的制造，例如使用真空挤出机或注射成型机。生产用于塑料加工的机器(如挤出机) 。橡胶生产，硫化机。不包括: 原料聚合物的生产工厂(化工)。' },
  { name: 'Y086-废物处理和环保', desc: '例如，溶剂回收装置; 土壤的废物处理; 废水处理、水脱气、水脱盐、废气净化。' },
  { name: 'Y087-玻璃、石材和陶瓷', desc: '使用真空成型制造玻璃零件。陶瓷的脱气；砖、瓦、瓦、陶瓷、隔离材料、石墨和碳材料的生产和干燥；建筑物(行人路、墙壁)的干燥。' },
  { name: 'Y088-竞争对手的服务', desc: '第三方服务提供商或直接竞争对手的服务公司(如Pfeiffer, Busch, Anest Iwata, Stokes, Rietschle)。' },
  { name: 'Y089-太阳能镀膜', desc: '太阳能电池(如薄膜CIGS和CdTe及晶圆镀膜)生产。' },
  { name: 'Y090-光伏层压', desc: '太阳能组件成品的生产(组装、贴合和测试)。' },
  { name: 'Y093-核能', desc: '铀(UF6)浓缩、(乏)燃料干燥、转化等。' },
  { name: 'Y094-可再生能源', desc: '使用可再生能源的发电的生产商和营办商，例如光热电发电厂、风力发电厂、生物质能发电厂等。碳捕获与储存。' },
  { name: 'Y095-经销商(非代理)', desc: '自由经销商，不受合同约束，服务于多个市场(特定市场分销商应列在其主要服务的分支代码下）' },
  { name: 'Y096-食品及天然产品加工', desc: '食品(包括宠物食品)在真空下的冷却、干燥、加工、输送、掏内脏(如翻滚、搅拌、切割、灌装、烘烤等);也可使用类似的(天然)产品如鲜花或皮革加工。专注于食品市场的分销商。' },
  { name: 'Y097-复合材料', desc: '复合材料的生产，例如通过注射工艺或RTM - light(树脂导流成型) 。生产风力机叶片。还有树脂脱气，高压釜脱气，真空装袋。' },
  { name: 'Y098-公用工程真空', desc: '其他使用真空作为“实用工具”的粗真空应用。原则上，应用应具有挑战性，也不包括不能用简单保护措施(如防尘过滤器或液体收集器)清除的有害介质。例如: 真空成型机、中央真空清扫系统等。' },
  { name: 'Y099-平板镀膜', desc: '用于大型显示器的镀膜：a)平板显示器(如液晶显示器，用于电视、平板电脑和智能手机的OLED)。b) 触摸面板(如电视、平板电脑和智能手机)。c) 柔性玻璃、金属和聚合物基板(如用于印刷电子产品)单体、连续或R2R镀膜机。' },
  { name: 'Y100-植物处理', desc: '生产 / 加工工业大麻产品或生产用于加工工业大麻的设备。' },
  { name: '无', desc: '无' },
]

const DepartmentCategoryMap = {
  '1': '服务',
  '2': '工业',
  '3': '科学',
}

const CommodityOrderQuotationMap = {
  '1': '商城订单',
  '2': '报价单',
  '3': '询价单',
}

const BannerCategoryMap = {
  1: '手动填写',
  2: '商品',
  3: '市场活动',
}

const CommodityPhs = [
  { value: 'China spares' },
  { value: 'Oils' },
  { value: 'Cryo' },
  { value: 'Varodry' },
  { value: 'Dryvac' },
  { value: 'Screwline' },
  { value: 'Scroll+' },
  { value: 'Scroll D / Iwata' },
  { value: 'Leyvac' },
  { value: 'Ecodry' },
  { value: 'Ecodry old' },
  { value: 'Trivac' },
  { value: 'Triton' },
  { value: 'Diff' },
  { value: 'Valves' },
  { value: 'Componennts' },
  { value: 'E&DK' },
  { value: 'Ruvac' },
  { value: 'Gauges' },
  { value: 'Sogevac' },
  { value: 'Turbovac' },
  { value: 'T1600 ' },
  { value: 'TST' },
  { value: 'MAG' },
  { value: 'Divac' },
  { value: 'Sogevac Neo' },
  { value: 'Leyspec' },
  { value: 'Systems' },
  { value: 'Converters' },
  { value: 'Testleak' },
  { value: 'LDs old' },
  { value: 'LDs new' },
  { value: 'Vacube' },
  { value: 'Clawac' },
  { value: 'Calibration' },
]

const BusinessOpportunityTypeMap = {
  1: '备件',
  2: 'STC',
  3: 'FIELD SERVICE',
  4: 'HCP/ Audit',
  5: 'Service Plan',
  6: 'Certified',
  7: 'Exchange pump',
}

// const DeviceApplicationMap = {
//     "LED照明": ["LED照明"],
//     "半导体": ["半导体行业", "半导体晶体生长"],
//     "镀膜": ["消费电子镀膜", "连续镀膜", "卷绕镀膜", "多功能镀膜", "单体镀膜", "Data Storage"],
//     "分析行业": ["质谱", "医疗扫描/治疗", "样品制备", "手套箱", "其他科学和仪器", "检漏仪", "电子显微镜", "表面分析"],
//     "公用真空": ["医院CVS", "公用真空", "废物处理"],
//     "化工&制药": ["药品冻干", "化工/制药"],
//     "能源&电力": ["新兴储能技术", "核能", "高端电池", "电力行业", "电厂", "EPC Power"],
//     "普通工业": ["蒸汽回收", "医疗设备", "陶瓷和石材", "容器制造", "人造宝石", "汽车制造", "其他运输系统", "其他冻干应用", "普通工业", "检漏系统", "环境模拟腔", "工业低温技术", "飞机/太空制造商", "等离子处理"],
//     "其它": ["竞争对手", "第三方服务机构"],
//     "热处理和冶金": ["冶金", "焊接设备", "工业炉", "钢液除气"],
//     "食品加工&包装": ["植物制剂", "食用油", "食品冷冻干燥", "食品加工", "食品包装", "罐装食品", "FPP经销商"],
//     "太阳能": ["太阳能晶体生长", "太阳能镀膜", "太阳能层压"],
//     "显示器": ["显示器生产"],
//     "橡塑": ["橡胶", "塑料再生", "塑料加工", "复合材料"],
//     "研发领域": ["实验室贸易商", "空间研究", "大学/研究机构", "大型科研中心", "R&D设备生产商", "R&D其它"],
//     "真空充注": ["普通真空充注", "工业气体", "RAC 制冷和空调", "CCUS"],
// }

const DeviceApplicationOptions = [
  { 'value': 'LED照明', 'label': 'LED照明', 'children': [{ 'value': 'LED照明', 'label': 'LED照明' }] },
  {
    'value': '半导体',
    'label': '半导体',
    'children': [
      { 'value': '半导体行业', 'label': '半导体行业' },
      { 'value': '半导体晶体生长', 'label': '半导体晶体生长' },
    ],
  },
  {
    'value': '镀膜',
    'label': '镀膜',
    'children': [
      { 'value': '消费电子镀膜', 'label': '消费电子镀膜' },
      { 'value': '连续镀膜', 'label': '连续镀膜' },
      { 'value': '卷绕镀膜', 'label': '卷绕镀膜' },
      { 'value': '多功能镀膜', 'label': '多功能镀膜' },
      { 'value': '单体镀膜', 'label': '单体镀膜' },
      { 'value': 'Data Storage', 'label': 'Data Storage' },
    ],
  },
  {
    'value': '分析行业',
    'label': '分析行业',
    'children': [
      { 'value': '质谱', 'label': '质谱' },
      { 'value': '医疗扫描/治疗', 'label': '医疗扫描/治疗' },
      { 'value': '样品制备', 'label': '样品制备' },
      { 'value': '手套箱', 'label': '手套箱' },
      { 'value': '其他科学和仪器', 'label': '其他科学和仪器' },
      { 'value': '检漏仪', 'label': '检漏仪' },
      { 'value': '电子显微镜', 'label': '电子显微镜' },
      { 'value': '表面分析', 'label': '表面分析' },
    ],
  },
  {
    'value': '公用真空',
    'label': '公用真空',
    'children': [
      { 'value': '医院CVS', 'label': '医院CVS' },
      { 'value': '公用真空', 'label': '公用真空' },
      { 'value': '废物处理', 'label': '废物处理' },
    ],
  },
  {
    'value': '化工&制药',
    'label': '化工&制药',
    'children': [
      { 'value': '药品冻干', 'label': '药品冻干' },
      { 'value': '化工/制药', 'label': '化工/制药' },
    ],
  },
  {
    'value': '能源&电力',
    'label': '能源&电力',
    'children': [
      { 'value': '新兴储能技术', 'label': '新兴储能技术' },
      { 'value': '核能', 'label': '核能' },
      { 'value': '高端电池', 'label': '高端电池' },
      { 'value': '电力行业', 'label': '电力行业' },
      { 'value': '电厂', 'label': '电厂' },
      { 'value': 'EPC Power', 'label': 'EPC Power' },
    ],
  },
  {
    'value': '普通工业',
    'label': '普通工业',
    'children': [
      { 'value': '蒸汽回收', 'label': '蒸汽回收' },
      { 'value': '医疗设备', 'label': '医疗设备' },
      { 'value': '陶瓷和石材', 'label': '陶瓷和石材' },
      { 'value': '容器制造', 'label': '容器制造' },
      { 'value': '人造宝石', 'label': '人造宝石' },
      { 'value': '汽车制造', 'label': '汽车制造' },
      { 'value': '其他运输系统', 'label': '其他运输系统' },
      { 'value': '其他冻干应用', 'label': '其他冻干应用' },
      { 'value': '普通工业', 'label': '普通工业' },
      { 'value': '检漏系统', 'label': '检漏系统' },
      { 'value': '环境模拟腔', 'label': '环境模拟腔' },
      { 'value': '工业低温技术', 'label': '工业低温技术' },
      { 'value': '飞机/太空制造商', 'label': '飞机/太空制造商' },
      { 'value': '等离子处理', 'label': '等离子处理' },
    ],
  },
  {
    'value': '其它',
    'label': '其它',
    'children': [
      { 'value': '竞争对手', 'label': '竞争对手' },
      { 'value': '第三方服务机构', 'label': '第三方服务机构' },
    ],
  },
  {
    'value': '热处理和冶金',
    'label': '热处理和冶金',
    'children': [
      { 'value': '冶金', 'label': '冶金' },
      { 'value': '焊接设备', 'label': '焊接设备' },
      { 'value': '工业炉', 'label': '工业炉' },
      { 'value': '钢液除气', 'label': '钢液除气' },
    ],
  },
  {
    'value': '食品加工&包装',
    'label': '食品加工&包装',
    'children': [
      { 'value': '植物制剂', 'label': '植物制剂' },
      { 'value': '食用油', 'label': '食用油' },
      { 'value': '食品冷冻干燥', 'label': '食品冷冻干燥' },
      { 'value': '食品加工', 'label': '食品加工' },
      { 'value': '食品包装', 'label': '食品包装' },
      { 'value': '罐装食品', 'label': '罐装食品' },
      { 'value': 'FPP经销商', 'label': 'FPP经销商' },
    ],
  },
  {
    'value': '太阳能',
    'label': '太阳能',
    'children': [
      { 'value': '太阳能晶体生长', 'label': '太阳能晶体生长' },
      { 'value': '太阳能镀膜', 'label': '太阳能镀膜' },
      { 'value': '太阳能层压', 'label': '太阳能层压' },
    ],
  },
  { 'value': '显示器', 'label': '显示器', 'children': [{ 'value': '显示器生产', 'label': '显示器生产' }] },
  {
    'value': '橡塑',
    'label': '橡塑',
    'children': [
      { 'value': '橡胶', 'label': '橡胶' },
      { 'value': '塑料再生', 'label': '塑料再生' },
      { 'value': '塑料加工', 'label': '塑料加工' },
      { 'value': '复合材料', 'label': '复合材料' },
    ],
  },
  {
    'value': '研发领域',
    'label': '研发领域',
    'children': [
      { 'value': '实验室贸易商', 'label': '实验室贸易商' },
      { 'value': '空间研究', 'label': '空间研究' },
      { 'value': '大学/研究机构', 'label': '大学/研究机构' },
      { 'value': '大型科研中心', 'label': '大型科研中心' },
      { 'value': 'R&D设备生产商', 'label': 'R&D设备生产商' },
      { 'value': 'R&D其它', 'label': 'R&D其它' },
    ],
  },
  {
    'value': '真空充注',
    'label': '真空充注',
    'children': [
      { 'value': '普通真空充注', 'label': '普通真空充注' },
      { 'value': '工业气体', 'label': '工业气体' },
      { 'value': 'RAC 制冷和空调', 'label': 'RAC 制冷和空调' },
      { 'value': 'CCUS', 'label': 'CCUS' },
    ],
  },
]

export {
  CommodityOrderQuotationMap,
  BusinessOpportunityTypeMap,
  CommodityPhs,
  BannerCategoryMap,
  DepartmentCategoryMap,
  CustomerUsages,
  ApproveEventTypeMap,
  NoticeStatusMap,
  FlowCategoryMap,
  CustomerDeviceStatusMap,
  ProductPromotionStatusMap,
  UsedDeviceStatusMap,
  DeviceQuestStatusMap,
  CustomerStatusMap,
  CustomerCategroyMap,
  AreaTextMap,
  PurchaseOrderStatusMap,
  ShippingRecordStatusMap,
  DeviceWorkConditions,
  DeviceRunTimes,
  QuotationStatusMap,
  TodoTypeMap,
  CustomerOrderStatusMap,
  CustomerOrderLogMap,
  CutomerLogTypes,
  CustomerFollowupTypes,
  Monthes,
  CustomerActiveMap,
  CustomerLogMap,
  PurchaseOrderLogMap,
  CsutomerIndustries,
  DealerRanks,
  DealerCategories,
  LoginEntrances,
  ServiceQuestLevelMap,
  ServiceQuestSourceMap,
  ServiceQuestStatusMap,
  ServiceQuestModeStatus,
  ServiceQuestResponseTip,
  ServiceQuestFlow,
  ServiceQuestMode,
  NoticeCategoryMap,
  FunctionalRoles,
  SMSStatusMap,
  CommodityOrderStatusMap,
  ServiceQuestCategory,
  ServiceQuestCMMCategoryTextMap,
  ServiceQuestModeAuth,
  ServiceQuestCMMCategory,
  WarrantyTypes,
  PSETestings,
  DeviceApplicationOptions,
}
